module.exports = {
	path: '/dealers',
	component: require('@views/Reps').default,
	meta: {
		showButton: true,
		title: 'Dealers',
		icon: ['far', 'users'],
		primary: true,
		search: {
			placeholder: 'Search Quotes & Orders',
			show: true,
		},
	},
};
